// Note: Parameters of coreCommonController are fixed - injection does not work here. Use $injector to inject additional services or providers
function coreCommonController(
  eName,
  controller,
  mode,
  $scope,
  $rootScope,
  CoreREST,
  service,
  $http,
  $timeout,
  $log,
  $dialog,
  $injector,
  $route,
  FavoriteService,
  i18nFilter,
  userSettingsService,
  UserSessionStorageService,
  navigationService
) {
  'use strict';

  var $location = $injector.get('$location'),
    $q = $injector.get('$q'),
    $resource = $injector.get('$resource'),
    journalRenderService = $injector.get('journalRenderService'),
    autoSaveServiceFactory = $injector.get('autoSaveServiceFactory'),
    userSettingsService = $injector.get('userSettingsService'),
    UserSessionStorageService = $injector.get('UserSessionStorageService'),
    navigationService = $injector.get('navigationService'),
    autoSaveService;

  var sysCataloguePromise;

  var shownDetailsId = null;

  var detailsReady = false;
  controller.details = undefined;
  $scope.details = undefined;

  $scope.journalRenderer = journalRenderService.journalRenderer;

  var ctrl = controller,
    gridScope;

  var tabShowListenerManager = createTabShowListenerManager();

  ctrl.showInactive = !mode.hasActive;
  ctrl.resetDetails = resetDetails;

  controller.selectedTab = controller.selectedTab || undefined;

  controller.onSelectTab = onSelectTab;
  controller.createTabShowListenerFn =
    tabShowListenerManager.createRegisterListenerFn;

  $scope.$watch('ctrl.showInactive', function(newval, oldval) {
    if (newval !== oldval) {
      //the first call guarantees newval ==oldval
      ctrl.updateList();
    }
  });

  $scope.$on('$destroy', function() {
    var isLoadingCatalogue =
      sysCataloguePromise &&
      sysCataloguePromise._httpTimeout &&
      sysCataloguePromise._httpTimeout.resolve;
    console.info('######## destroy sysCataloguePromise 1');
    if (isLoadingCatalogue) {
      sysCataloguePromise._httpTimeout.resolve();
    }
    console.info('######## destroy sysCataloguePromise 2');
  });

  function getGridScope() {
    if (!gridScope) {
      gridScope = $('#dataGrid').isolateScope();
    } else {
      // gridscope variable already set
    }

    return gridScope;
  }

  controller.getVisibleId = function() {
    return shownDetailsId;
  };

  controller.setVisibleId = function(id) {
    shownDetailsId = id;
  };

  function createUniqueFeId() {
    var idText = controller.currentIdNum++ + '';
    while (idText.length < 12) {
      idText = '0' + idText;
    }
    return '00000000-0000-0000-0000-' + idText;
  }

  function resetDetails(shouldUpdateList, shouldReopenDetails) {
    let fieldId = undefined;
    if(shouldReopenDetails) {
      fieldId = controller.details.field.id;
    }
    detailsReady = false;
    controller.details = undefined;
    $scope.details = undefined;
    controller.removeValidation();

    if (shouldUpdateList) {
      controller.updateList()
        .then(() => {
          if(shouldReopenDetails) {
            let field = _.find(controller.listData, function(item) {
              return item.id === fieldId;
            });
            controller.cellClick(undefined, field);
          }
      });
    }

    $location.path(app.getBacklinkRoute('/core/' + eName + '/'));
    controller.ensureSelectionInView();
    shownDetailsId = null;
  }

  controller.submit = function() {
    $log.debug('submit called');
  };

  controller.cellClick = function(columnName, rowData) {
    if (columnName !== 'active' && !rowData.isASysCatalalogueItem) {
      $location.path(app.getBacklinkRoute('/core/' + eName + '/' + rowData.id));
    }
  };

  /**
   * Handle a response from a load action (result contains all details)
   */
  var handleLoadResponse = function(result) {
    $scope.details = result;
    controller.details = result;
    if (controller.details.field !== undefined && controller.details.field.id !== null) {
      controller.getFieldNotes();
      controller.getFieldBiodiversityData();
    } else {
      controller.notes = "";
      controller.fieldBiodiversityData = controller.defaultFieldBiodiversityData;
    }
    controller.markCurrentStateSaved();
    controller.onAfterLoad($scope.details);
    controller.currentIdNum = 1; // reset own generated ids
    controller.onShowDetails();
    controller.syncSelection();
  };

  controller.addClick = function(data) {
    var theData = data || {};
    autoSaveService.flush().then(function() {
      controller.startLoad();
      detailsReady = $scope.detailsVisible(); // wenn schon offen.. sollte es hierbei offen bleiben!
      service.create(theData, function(result) {
        handleLoadResponse(result);
        $scope.dataForm.$setPristine(); // form is clean
        detailsReady = true;
        controller.updateList();
        angular
          .element('.tabbable')
          .isolateScope()
          .tabs[0].select(); // reset all tabs
        setTimeout(function() {
          $('.tabContent input[type=text]:first')
            .focus()
            .select();
        }, 100);
      });
    });
  };

  controller.ensureSelectionInView = function() {
    // note: we need to wait two rounds of dom update because in most cases the core data draw update works in two steps
    ang.callAfter(function() {
      ang.callAfter(function() {
        // get grid scope and use grids scrollIntoView function if we have at least one selected element
        var dataGrid = $('#dataGrid'),
          gridScope = dataGrid.scope();
        if (
          gridScope &&
          gridScope.controller &&
          dataGrid.find('.selected').length > 0
        ) {
          gridScope.scrollSelectionIntoView();
        }
      });
    });
  };

  // check for entries marked as selected in the grid
  controller.isAnythingSelected = function() {
    return _.some(controller.listData, function(item) {
      return item.$cfngrid_selected;
    });
  };

  // number of items displayed on one page
  controller.getItemsPerPage = function() {
    var gridscope = getGridScope();
    if (gridscope && gridscope.view) {
      return gridscope.view.perPage;
    }
    return null;
  };

  controller.onShowDetails = function() {
    if ($scope.dataForm) {
      $scope.dataForm.$setPristine(); // form is clean
    }

    // get tab scopes of external component.
    var tabScope = $('.tabbable').scope();
    if (tabScope && tabScope.tabs) {
      var switchToFirstTab = false;
      // check if a tab is active and has the showIf = false
      for (var t in tabScope.tabs) {
        if (tabScope.tabs.hasOwnProperty(t)) {
          var tab = tabScope.tabs[t];
          if (tab.active && tab.showIf === false) {
            switchToFirstTab = true; // tab is no longer visible
          }
        }
      }
      if (switchToFirstTab) {
        // reset all tabs
        tabScope.tabs[0].select();
      }
    }
    controller.ensureSelectionInView();
    detailsReady = true;
    if ($scope.details !== undefined) {
      if (mode.hasCalendar) {
        // directly update calendar
        Calendar.ShowDetailsCalendar(
          $('#calendar'),
          $scope.details[eName + 'CalendarData'],
          $injector
        );
      }
      controller.updateValidation();
      controller.updateFavorite();
    }
    // journal clear
    controller.clearJournal();
  };

  controller.callShowTab = function(tab) {
    controller.selectedTab = tab;
    ang.callAfter(function() {
      $rootScope.window.forceResize();
      controller.onShowTab(tab);
    }, $scope);
  };

  controller.onShowTab = function(tab) {
    $log.debug('tab selected ' + tab);
    if (
      mode.hasCalendar &&
      tab === 'calendar' &&
      $scope.details !== undefined
    ) {
      Calendar.ShowDetailsCalendar(
        $('#calendar'),
        $scope.details[eName + 'CalendarData'],
        $injector
      );
    }
    if (tab === 'journal') {
      controller.clearJournal();
    }
    tabShowListenerManager.callListeners(tab);
    $rootScope.window.forceResize();
  };

  controller.clearJournal = function() {
    controller.selectedJournal = null;
    var gridScope = $('#journalGrid').isolateScope();
    if (gridScope && gridScope.controller && gridScope.grid) {
      gridScope.controller.clearSelection();
    }
  };

  controller.journalClicked = function(journal) {
    controller.selectedJournal = journal;
  };

  // sync selection with currently selected details
  controller.syncSelection = function() {
    if (
      controller.details !== undefined &&
      controller.details[eName] !== undefined
    ) {
      $timeout(function() {
        // we need to call the sync after changes of the grid
        var gridScope = $('#dataGrid').isolateScope() || {};
        if (
          gridScope.controller &&
          controller.details &&
          controller.details[eName] &&
          //this will always get triggered, since grid looses the selection, so do it only if details view
          //is synced (prevents flickering of te row selection marker)
          controller.details[eName].id == shownDetailsId
        ) {
          gridScope.controller.setSelectedRowById(controller.details[eName].id);
        }
      }, 0);
    }
  };

  controller.updateList = function() {
    var query = 'query';
    if (
      eName &&
      eName != 'fertilizer' &&
      eName != 'plantProtectant' &&
      eName != 'seed'
    ) {
      if (!ctrl.showInactive) {
        query = 'queryActiveOnly';
      }
    }
    //console.debug("query!", query, ctrl.showInactive);
    var result = service[query]({}, function() {
      controller.listData = result;
      addAllSysCatalogueItemsToList();
      controller.syncSelection();
    });

    return result.$promise;
  };

  controller.deleteClick = function() {
    if (
      controller.details === null ||
      controller.details === undefined ||
      controller.details[eName] === null ||
      controller.details[eName] === undefined
    ) {
      $rootScope.alertController.addTemporaryAlert(
        i18nFilter('fe.common.nothingSelected', 'nichts ausgewählt')
      );
    } else if (controller.details[eName].id === null) {
      resetDetails();
      detailsReady = false; // hide details
      controller.details = undefined;
      $scope.details = undefined;
      $rootScope.alertController.addTemporaryAlert(
        i18nFilter('fe.common.cancelCreate', 'erstellen abgebrochen')
      );
    } else {
      $dialog
        .messageBox(
          i18nFilter('fe.common.delete', 'Löschen?'),
          i18nFilter('fe.common.areYouSure'),
          [
            { result: 'cancel', label: i18n('fe.common.cancel') },
            {
              result: 'ok',
              label: i18n('fe.common.ok'),
              cssClass: 'btn-primary'
            }
          ]
        )
        .open()
        .then(controller.delete);
    }
  };

  controller.delete = function(result) {
    if (result !== 'ok') {
      return false;
    }
    detailsReady = false; // hide details
    var id = controller.details[eName].id;
    controller.details = undefined;
    $scope.details = undefined;
    // liste updaten

    service.delete({ id: id }, function(response) {
      resetDetails(true);
      if (response.messages.length === 0) {
        $rootScope.alertController.addTemporaryAlert(
          i18nFilter('fe.common.deleteSuccess', 'Erfolgreich gelöscht'),
          'success'
        );
      } else {
        $rootScope.handleMsgContext(response);
      }
    });
  };

  controller.propertyChanged = function() {
    // a property has been changed. Directly trigger save
    ang.callAfter(function() {
      // callAfter, so e.g. cost component can update transitive fields
      autoSaveService.flush(controller.toSaveModel(ctrl.details));
    }, $scope);
  };

  controller.updateFavorite = function() {
    // update favorite
    var link = '/core/' + eName + '/' + $scope.details[eName].id;
    controller.isFavorite = FavoriteService.isFavorite(eName, link);
  };

  controller.favoriteClick = function() {
    var name = controller.getEntityName();
    var link = '/core/' + eName + '/' + $scope.details[eName].id;
    controller.isFavorite = !controller.isFavorite;
    if (controller.isFavorite) {
      FavoriteService.addFavorite(name, eName, link);
    } else {
      FavoriteService.removeFavorite(name, eName, link);
    }
  };

  // no longer used
  controller.activeChange = function(value, rowData) {
    $http.post('/365FarmNet/rest/core/' + eName.toLowerCase() + '/activate', {
      id: rowData.id,
      active: value
    });
  };

  controller.setDetailsById = function(id, options, comeFromMap) {
    if (comeFromMap) {
      controller.cellClick(undefined, comeFromMap);
    }
    var theOptions = options || {};
    if (!id) {
      throw 'setDetailsById requires id';
    }
    if (id !== shownDetailsId) {
      // Make sure the old entity has been saved
      autoSaveService.flush().then(function() {
        // wenn schon offen.. sollte es hierbei offen bleiben!
        detailsReady = $scope.detailsVisible();
        shownDetailsId = id;
        controller.startLoad();
        ang.callServiceOnce(service, { id: id }, function(result) {
          handleLoadResponse(result);
          // TODO: Why would we want to save directly after loading?
          if (theOptions.saveAfter) {
            controller.saveNow();
          }
        });
      });
    }
  }; // setDetailsById

  controller.startLoad = function() {
    controller.removeValidation();

    //app.startLoading();
  };

  // Empty function that can be overwritten
  controller.onAfterLoad = function() {};

  $rootScope.displayRight = false; // initial display right is disabled

  controller.closeDetails = function() {
    autoSaveService.flush().then(resetDetails);
  };

  $scope.detailsVisible = function() {
    var visible =
      detailsReady ||
      (controller.details &&
        controller.details[eName] &&
        controller.details[eName].id !== null);
    $rootScope.window.displayRight = visible;
    // detailsready is for the case that a new object is being created (id would be null there)
    return visible;
  };

  // function for all rest calls that directly update the details
  controller.callRest = function(path, doUpdateList, callback) {
    return function(data, openDetails) {
      // Make sure pending changes are saved first
      autoSaveService.flush().then(function() {
        $http
          .post(
            '/365FarmNet/rest/core/' + eName.toLowerCase() + '/' + path,
            data
          )
          .then(function(response) {
            var result = response.data;
            var ob;
            if (result.type === 'referenceChange') {
              ob = controller.details[eName];
              if (ob) {
                ob[result.field] = result.value;
              }
            } else if (result.type === 'referenceAdd') {
              var listName = eName + '_' + result.field;
              ob = controller.details[listName];
              if (ob) {
                $.each(result.value, function(i, v) {
                  if (v.id === null) {
                    // ensure unique frontend id to be able to use frontend mapping
                    v.id = createUniqueFeId();
                  }
                  ob.push(v);
                });

                // ASC: validation hack CFNPOC-33209
                if(listName === 'cropSequence_crops'){
                  controller.updateValidation();
                }
              }
            } else if (result[eName] && openDetails) {
              // object returned
              if (result[eName].id) {
                controller.setDetailsById(result[eName].id);
                // load it again. this usually means we creates something by template.
              } else {
                $log.warn('No id return from REST call');
              }
            }

            if (angular.isFunction(callback)) callback(result);

            // Save again, if necessary
            controller.saveNow().then(function() {
              if (doUpdateList) {
                controller.updateList();
              }
            });
          });
      });
    };
  };

  /**
   * Adds functions to the controller to manage sub-items
   */
  var injectSubItemFunctions = function(i) {
    var special = mode.specialAdd[i],
      listName = eName + '_' + special.property,
      /**
       * Define a function in the controller to init/open/close the popup
       */
      initPopup = function() {
        $rootScope['modal' + special.property + 'Open'] = false;
        // TODO: I assume Edit flag is not needed any more, but keeping it here
        // to not break anything
        $rootScope['modal' + special.property + 'Edit'] = true;
      },
      openCreatePopup = function() {
        $rootScope['modal' + special.property + 'Edit'] = false;
        addItem();
        $rootScope['modal' + special.property + 'Open'] = true;
        $rootScope.modalActive = true;
      },
      openEditPopup = function(item) {
        $rootScope['modal' + special.property + 'Edit'] = true;
        $rootScope.modalItem = item;
        $rootScope['modal' + special.property + 'Open'] = true;
        $rootScope.modalActive = true;
      },
      closePopup = function() {
        $rootScope['modal' + special.property + 'Open'] = false;
        $rootScope.modalActive = false;
      },
      onPopupClosed = function() {
        var item = $rootScope.modalItem,
          // We assume an object is empty if it contains only the id but no actual content field
          hasAnyProperty = Object.getOwnPropertyNames(item).some(function(val) {
            return val !== 'id' && val.substr(0, 2) !== '$$';
          });
        // Remove item if empty
        if (!hasAnyProperty) {
          removeItem(item);
        }
        $rootScope['modal' + special.property + 'Open'] = false;
        $rootScope.modalActive = false;
      },
      removeItem = function(item) {
        $.arrayRemove(ctrl.details[listName], item);
        ctrl.details[listName + '_removed'].push(item);
        /* remember deleted */
        ctrl.propertyChanged(special.Property); // register property change
      },
      addItem = function() {
        var ob = {};
        // generate a clientId that is unique inside the details controller on both sides.
        // this is required to map the newly created items
        ob.id = createUniqueFeId();

        $rootScope.modalItem = ob;
        ctrl.details[listName].push(ob);
        return ob;
      };

    // Inject function to the controller
    if (special.editable) {
      ctrl['add' + special.Property] = addItem;
    }

    initPopup();

    ctrl['remove' + special.Property] = removeItem;
    ctrl['open' + special.Property + 'CreatePopup'] = openCreatePopup;
    ctrl['open' + special.Property + 'EditPopup'] = openEditPopup;
    ctrl['close' + special.Property + 'Popup'] = closePopup;
    ctrl['on' + special.Property + 'PopupClosed'] = onPopupClosed;
  };

  $rootScope.modalItem = null;
  for (var i in mode.specialAdd) {
    if (mode.specialAdd.hasOwnProperty(i)) {
      injectSubItemFunctions(i);
    }
  }

  // / grid infos
  controller.findGridRow = function(id) {
    // update list view
    var foundIndex = -1;
    for (var i in controller.listData) {
      if (controller.listData.hasOwnProperty(i)) {
        var ob = controller.listData[i];
        if (ob.id == id) {
          foundIndex = i;
          break;
        }
      }
    }
    return foundIndex;
  };

  controller.updateGrid = function() {};

  /**
   * Wrapper for the handleSaveResponse function.
   */
  var handleSaveResponseWrapper = function(data, sentModel) {
    // NOTE `handleSaveResponseWrapper()` wraps `autoSaveServiceFactory.js:95` `saveResponseHandler()`
    return $q.all(controller.handleSaveResponse(data, sentModel));
  };

  /**
   * Handle the server response together with the model that was sent (might be different already)
   */
  controller.handleSaveResponse = function(data, sentModel) {
    var dataLoaded = $q.defer();
    var ob = controller.details ? controller.details[eName] : false;
    var shouldRetrieveModifiedDetails =
      ob && data.hasModifiedChildDTO === true && data.id;

    if (shouldRetrieveModifiedDetails) {
      //defined in model DTO used for signaling that more changes have been made, than those sent  in data.
      service.get({ id: data.id }, function(newDTO) {
        handleLoadResponse(newDTO);
        dataLoaded.resolve();
      });
    } else {
      dataLoaded.resolve();
    }

    return dataLoaded.promise.then(function() {
      // update data from result.
      if (ob) {
        //$log.debug("update from backend. id:%s, idChange:%s",ob.id,data.idChange);
        ob.messagingContext = data.messagingContext; // update messages
        // Backend notifies us that the ID has changed
        // CFNPOC-7254 only do this if the id is empty, i.e. the created object is still in scope.
        if (data.idChange && !ob.id) {
          ob.id = data.idChange;
          sentModel[eName].id = data.idChange;
          $log.debug('id changed ' + ob.id);
          controller.syncSelection(); // sync selection, we changed the user
        }
        // Backend notifies us that our temporary IDs have been replaced with database IDs
        if (data.listids) {
          // if list ids have been mapped

          $.each(data.listids, function(property, list) {
            // update mapping of list ids
            var listName = eName + '_' + property;
            $.each(list, function(i, mapping) {
              // find object that has the mapped id inside the correct list
              $.each(controller.details[listName], function(k, listEle) {
                if (listEle.id === mapping[0]) {
                  listEle.id = mapping[1]; // use the mapped id
                }
              });
              $.each(sentModel[listName], function(k, listEle) {
                if (listEle.id === mapping[0]) {
                  listEle.id = mapping[1]; // use the mapped id
                }
              });
            });
          });
        }
        // Backend notifies us about calculated fields
        if (data.calculatedFields) {
          $.each(data.calculatedFields, function(property, value) {
            if (controller.details[eName]) {
              controller.details[eName][property] = value;
            }
            if (sentModel[eName]) {
              sentModel[eName][property] = value;
            }
          });
        }

        // Tell save service that we have modified the current model (with new IDs)
        autoSaveService.updateClientModel(
          controller.toSaveModel(controller.details)
        );
      }
      controller.beValidationFields = {};
      var hasErrors = controller.checkBEValidationChanges();
      if (!hasErrors) {
        $rootScope.alertController.addTemporaryAlert(
          i18nFilter('fe.common.savedMsg', 'Änderungen gespeichert'), 'success'
        );
      } else {
        $rootScope.alertController.addTemporaryAlert(
          i18nFilter(
            'fe.common.error.noSaveMsg',
            'evtl. wurden nicht alle Änderungen gespeichert.'
          ),
          'error'
        );
      }

      if (data.listObject) {
        var found = false;
        for (var i = 0; i < controller.listData.length; i++) {
          if (controller.listData[i].id === data.listObject.id) {

            // replace the list data with an actual data which came from BE
            for(var key in controller.listData[i]) {
              if (data.listObject.hasOwnProperty(key) && controller.listData[i][key] !== data.listObject[key]) {
                controller.listData[i][key] = data.listObject[key];
              }
            }

            // edit list data with an actual data from edit form
            // we do this, because by a field add empty form fields are not added to a model, so they can not be updated in the
            // list on the fly
            for(var formDataKey in data.listObject) {
              if (!controller.listData[i].hasOwnProperty(formDataKey)) {
                controller.listData[i][formDataKey] = data.listObject[formDataKey];
              }
            }
            found = true;
            break;
          }
        }
        if (!found) {
          controller.listData.push(data.listObject);
        }
        var gridScope = $('#dataGrid').isolateScope();
        if (gridScope && gridScope.controller) {
          gridScope.updateModel();
          // Selection in list is lost, so restore
          controller.syncSelection();
        }
      }
      $scope.$broadcast('coredata_saved');
    });
  };

  controller.resetDirtyFlags = function() {
    // will be overwritten by specific controller, i.e. personCoreCustom.js, machineCoreCustom, ...
  };

  /**
   * Removes all unnecessary fields from model to prevent unnecessary saves. Can be overridden to
   * send/check even more.
   *
   * @param viewModel
   * @returns {object} cleaned up view model, save model
   */
  controller.toSaveModel = function(viewModel) {
    // Return null/undefined as is
    if (!viewModel) {
      return viewModel;
    }

    var saveModel = $.extend(true, {}, viewModel);
    if (saveModel[eName]) {
      // Validation messages should not trigger saves
      delete saveModel[eName].messagingContext;
      delete saveModel[eName].listJSON;
    }
    return saveModel;
  };

  autoSaveService = autoSaveServiceFactory.getInstance(
    '/365FarmNet/rest/core/' + eName.toLowerCase() + '/',
    handleSaveResponseWrapper
  );

  /**
   * Function to trigger immediate save, if necessary
   * @returns promise that is resolved as soon as no save is pending
   */
  controller.saveNow = function() {
    $log.debug('saveNow()');

    $scope.dataForm.$setPristine(); // form is clean
    return autoSaveService.flush(controller.toSaveModel($scope.details)); // save the new `data`
  };

  controller.markCurrentStateSaved = function() {
    autoSaveService.updateServerModel(
      controller.toSaveModel(controller.details)
    );
  };

  // TODO: this actually might be a bit to slow to watch for EVERYTHING
  $scope.$watch(
    eName + 'CoreController.details',
    function(newVal, oldVal) {
      // Skip initial event
      if (newVal === oldVal) {
        return;
      }
      autoSaveService.updateClientModel(controller.toSaveModel(newVal));
    },
    true
  );

  // end save part

  // validation part
  var validationGroupInfo = mode.vgi;
  var validationForm = $("form[name='dataForm']");

  function getTabByKey(key) {
    var k = key;
    if (k.indexOf('__') !== -1) {
      k = k.substr(0, k.indexOf('__'));
    }
    return validationGroupInfo[k];
  }

  controller.updateBEValidation = function() {
    var tabErrors = {};
    var hasErrors = false;
    controller.beValidationFields = {};
    if (
      controller.details &&
      controller.details[eName] &&
      controller.details[eName].messagingContext
    ) {
      var context = controller.details[eName].messagingContext;
      for (var i in context.messages) {
        if (context.messages.hasOwnProperty(i)) {
          var msg = context.messages[i];
          if (msg.localeKey) {
            msg.value = i18nFilter(msg.localeKey, msg.value);
          }
          msg.localeKey = null;
          if (!msg.key || msg.key === '') {
            controller.beValidationFields[msg.value] = true; // store allready done validation
            if (msg.type === 'ERROR') {
              $rootScope.alertController.addTemporaryAlert(msg.value, 'error');
              hasErrors = true;
            } else {
              $rootScope.alertController.addTemporaryAlert(
                msg.value,
                'warning'
              );
            }
          }
          if ((msg.type === 'ERROR' || msg.type === 'WARNING') && msg.key) {
            var tab = getTabByKey(msg.key);
            if (!tab) {
              $log.debug('Tab for ' + msg.key + ' not found');
            } else {
              if (
                $('#tabContent' + tab).is(':visible') ||
                $('#tabContent' + tab + '_0').is(':visible')
              ) {
                controller.beValidationFields[msg.key] = true;
                if (msg.type === 'ERROR') {
                  $('#' + msg.key.toLowerCase()).validationEngine(
                    'showPrompt',
                    msg.value,
                    'error',
                    'bottomLeft',
                    true
                  );
                  hasErrors = true;
                } else {
                  // TODO: Style for Warnings
                  $('#' + msg.key.toLowerCase()).validationEngine(
                    'showPrompt',
                    msg.value,
                    'error',
                    'bottomLeft',
                    true
                  );
                }
              } else {
                if (!tabErrors[tab]) {
                  tabErrors[tab] = 0;
                }
                tabErrors[tab]++;
              }
            }
          }
        }
      }

      var handleTabClick = function() {
        $(this).validationEngine('hide');
        hasErrors = controller.checkBEValidationChanges();
      };

      for (var tabError in tabErrors) {
        if (tabErrors.hasOwnProperty(tabError)) {
          var errorCount = tabErrors[tabError],
            elem = $('#tabHeader' + tabError);
          elem.validationEngine(
            'showPrompt',
            errorCount + ' ' + i18nFilter('fe.error.breadcrumb', ' Fehler'),
            'error',
            'bottomLeft',
            true
          );
          elem.off('click.cfn'); // remove old
          // handler
          elem.on('click.cfn', handleTabClick);
        }
      }
    }
    return hasErrors;
  };

  controller.checkBEValidationChanges = function() {
    $log.debug('checkBEValidationChanges');
    var hasErrors = false;
    if (
      controller.details &&
      controller.details[eName] &&
      controller.details[eName].messagingContext &&
      controller.details[eName].messagingContext.messages &&
      controller.details[eName].messagingContext.messages.length > 0 &&
      controller.beValidationFields
    ) {
      var oldFields = controller.beValidationFields;
      controller.beValidationFields = [];
      var context = controller.details[eName].messagingContext;
      for (var i in context.messages) {
        if (context.messages.hasOwnProperty(i)) {
          var msg = context.messages[i];
          if (msg.localeKey) {
            msg.value = i18nFilter(msg.localeKey, msg.value);
          }
          msg.localeKey = null;
          if (!msg.key || msg.key === '') {
            controller.beValidationFields[msg.key] = true; // store already done validation
            if (!oldFields[msg.key]) {
              if (msg.type === 'ERROR') {
                $rootScope.alertController.addTemporaryAlert(
                  msg.value,
                  'error'
                );
                hasErrors = true;
              } else {
                $rootScope.alertController.addTemporaryAlert(
                  msg.value,
                  'warning'
                );
              }
            }
          }

          if ((msg.type === 'ERROR' || msg.type === 'WARNING') && msg.key) {
            controller.beValidationFields[msg.key] = true;
            // neues prompt !
            var tab = getTabByKey(msg.key);
            if (!tab) {
              $log.debug('Tab for ' + msg.key + ' not found');
            } else {
              $log.debug('new prompt', msg.key);
              if (
                $('#tabContent' + tab).is(':visible') ||
                $('#tabContent' + tab + '_0').is(':visible')
              ) {
                controller.beValidationFields[msg.key] = true;
                if (msg.type === 'ERROR') {
                  $('#' + msg.key.toLowerCase()).validationEngine(
                    'showPrompt',
                    msg.value,
                    'error',
                    'bottomLeft',
                    true
                  ); // ,$("#"+msg.key.toLowerCase()));
                  hasErrors = true;
                } else {
                  // TODO: Style for Warnings
                  $('#' + msg.key.toLowerCase()).validationEngine(
                    'showPrompt',
                    msg.value,
                    'error',
                    'bottomLeft',
                    true
                  ); // ,$("#"+msg.key.toLowerCase()));
                }
              } // this should not happen actually...
            }
          }
        }
      }
      for (var key in oldFields) {
        if (
          oldFields.hasOwnProperty(key) &&
          !controller.beValidationFields[key]
        ) {
          $log.debug('closing old promopt', key);
          try {
            $('#' + key.toLowerCase()).validationEngine('hide');
            $('.' + key.toLowerCase() + 'formError').remove(); // ensure the promopt is removed even if the dom element isn't existing anymore;
          } catch (e) {
            $log.debug('error in closing ', e);
          }
        }
      }
    } else {
      // ASC: validation hack CFNPOC-33209
      // try to hide all popups that are still open in case that there is no error message given
      $('div.formError').hide();
    }
    return hasErrors;
  };

  controller.removeValidation = function() {
    validationForm.validationEngine('hide'); //hide all from this form
    $('.formError').hide(); // actually force form errors to be hidden
    validationForm.validationEngine('detach');
  };

  controller.updateValidation = function() {
    //call validation after angular finishes filling out the form fields with the model data
    ang.callAfter(function() {
      $log.debug('attach validation');
      validationForm.validationEngine('attach', {
        // relative: true,
        showPrompts: false,
        scroll: false,
        promptPosition: 'bottomLeft'
      });
      // only validate if allready has been saved
      if (
        controller.details &&
        controller.details[eName] &&
        controller.details[eName].id
      ) {
        validationForm.validationEngine('validate');
        controller.updateBEValidation();
      }
    });
  };
  controller.updateValidation();

  // end validation

  /**
   * Duplicates the selected entity
   */
  controller.duplicate = function() {
    var idToClone = controller.details[eName].id;
    controller.closeDetails();
    // Send the ID although current implementation always clones the currently selected entity
    service.duplicate({ id: idToClone }, function() {
      controller.updateList();
      $rootScope.alertController.addTemporaryAlert(
        i18nFilter('fe.common.duplicateSuccess', 'erfolgreich dupliziert'),
        'success'
      );
    });
  };

  // If URL referes to an entity, show details
  if ($route.current.params.id) {
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    var timeout = 500;
    if (isSafari) {
      timeout = 1700;
    }
    // Show details after a time, so map widget has time to initialize
    setTimeout(function() {
      ang.apply($scope, function() {
        controller.setDetailsById($route.current.params.id);
      });
    }, timeout);
  }

  addAllSysCatalogueItemsToList();

  function addAllSysCatalogueItemsToList() {
    if (eName !== 'plantProtectant' && eName !== 'fertilizer') {
      return;
    }

    // display 'please wait' dialog while loading plant protectant catalogue items
    if (eName === 'plantProtectant') {
      app.showLoader();
    }

    var sysCatalogueService = coreCommonRestService(
      'sys' + eName.toLowerCase(),
      $resource
    );

    sysCataloguePromise = sysCatalogueService.queryActiveOnly().$promise;
    sysCataloguePromise.then(function(sysCatalogueItems) {
      var userItems = controller.listData;

      sysCatalogueItems = _.chain(sysCatalogueItems)
        .map(function(item) {
          item.isASysCatalalogueItem = true;
          item.number = null;
          item.active = false;
          item.displayName = item.displayName || item.tradeName;

          // some mapping for seeds:
          if (item.sysCulture_category)
            item.sysSeed_sysCulture_category = item.sysCulture_category;
          if (item.sysCulture_abbrFruit)
            item.sysSeed_sysCulture_abbrFruit = item.sysCulture_abbrFruit;
          if (item.sysCulture_name)
            item.sysSeed_sysCulture_name = item.sysCulture_name;

          return item;
        })
        .filter(function(item) {
          return item.isActivated !== true; // filter out all sysCatalogue Items that the user has already activated
          // Note: item.isActivated is not the same as
          // item.active (it means the element has been "addByTemplate"d or the like)
        })
        .value();

      // combine user item list and catalogue item list
      controller.listData = controller.listData.concat(sysCatalogueItems);

      if (getGridScope() !== undefined) {
        getGridScope().controller.setFilter('active', true, true);
      }

      app.hideLoader();
    });
  }

  controller.onItemAdded = function(item) {
    //to be overwritten
  };

  controller.onToggleClick = function(item) {
    var isUserItem = !item.isASysCatalalogueItem;

    switch (true) {
      case item.isASysCatalalogueItem:
        doAddByTemplate(item);
        break;

      case isUserItem && item.active:
        doDeactivate(item);
        break;

      case isUserItem && !item.active:
        doActivate(item);
        break;
    }
  };

  function doAddByTemplate(sysCatalogueItem, opt) {
    var opt = _.defaults(opt || {}, {
      openDetails: false,
      doNotRefreshIndexList: false,
      onAddedByTemplate: function(data) {
        replaceItemInList(controller.listData, sysCatalogueItem, data[eName]);
      }
    });

    if (eName === 'seed' || eName === 'plantProtectant') {
      controller.callRest(
        'addByActivation',
        opt.doNotRefreshIndexList,
        opt.onAddedByTemplate
      )(sysCatalogueItem, opt.openDetails);
    } else if (eName === 'fertilizer') {
      controller.callRest(
        'addByTemplate',
        opt.doNotRefreshIndexList,
        opt.onAddedByTemplate
      )(sysCatalogueItem, opt.openDetails);
    }

    controller.onItemAdded(sysCatalogueItem);
  }

  function doActivate(listItem) {
    $http.put(
      '/365FarmNet/rest/core/' +
        eName.toLowerCase() +
        '/activate/' +
        listItem.id
    );

    if (controller.details && controller.details[eName].id === listItem.id) {
      controller.details[eName].active = true;
    }
  }

  function doDeactivate(itemActive) {
    $http.put(
      '/365FarmNet/rest/core/' +
        eName.toLowerCase() +
        '/deactivate/' +
        itemActive.id
    );

    if (controller.details && controller.details[eName].id === itemActive.id) {
      controller.details[eName].active = false;
    }
  }

  function replaceItemInList(list, sysCatalogueItem, userItem) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].id === sysCatalogueItem.id) {
        _.each(controller.listData[i], function(itemProperty, itemkey) {
          var reservedKeywords = ['$$hashKey', '$cfngrid_selected'];
          if (_(reservedKeywords).contains(itemkey)) {
            return;
          }

          controller.listData[i][itemkey] =
            userItem[itemkey] || controller.listData[i][itemkey];
        });

        controller.listData[i].isASysCatalalogueItem = false;
      }
    }
  }

  /**
   * Registers a tab as selected and calls the matching tab show listener if registered. Does no window resizing etc.
   * @param tabName Name of tab
   * @see registerTabShowListener
   */
  function onSelectTab(tabName) {
    controller.selectedTab = tabName;
    tabShowListenerManager.callListeners(tabName);
  }

  var thisRoute = $route.current;
  $scope.$on('$locationChangeSuccess', function() {
    // Staying inside this controller?
    $log.debug('$route', $route, $route.current, $route.current.$$route);
    if (
      $route.current.$$route &&
      $route.current.$$route.controller === eName + 'CoreController'
    ) {
      var detailsId = $route.current.params.id;
      // Prevent controller reload
      $route.current = thisRoute;
      // But switch to requested details page
      if (detailsId) {
        controller.setDetailsById(detailsId);
      }
    }
  });

  $scope.$on('goBackState', function() {
    controller.saveNow();
  });

  controller.listData = app.farmnetControllers.data;
  $scope.ctrl = ctrl;

  if (
    $rootScope.goBackState &&
    $rootScope.goBackState.type === 'core/' + eName
  ) {
    $log.debug('goback', $rootScope.goBackState);
    var goBack = $rootScope.goBackState;
    ang.callAfter(function() {
      $scope.details = goBack.data.details;
      controller.details = goBack.data.details;
      controller.currentIdNum = 1; // reset own generated ids
      controller.onShowDetails();
      controller.syncSelection();
    }, $scope);
    $rootScope.goBackStateFinished('fe.core.continue.message', 'fortgesetzt');
  }

  controller.goBackToCore = function(obType, id) {
    var logId = id || '';
    $log.debug('goBackToCore', obType, logId, eName);

    const targetUri = navigationService.getCoreRoute(obType, id);
    if (!$rootScope.pageTitle) {
      app.gotoWithBackButton(
        targetUri,
        'core/' + eName,
        i18nFilter('fe.core.backTo', 'zurück'),
        'core/' + eName,
        {
          details: $.extend(false, {}, $scope.details)
        }
      );
    } else {
      app.gotoWithBackButton(
        targetUri,
        'core/' + eName,
        i18nFilter('fe.core.backTo', 'zurück') +
          '(' +
          $rootScope.pageTitle +
          ')',
        'core/' + eName,
        {
          details: $.extend(false, {}, $scope.details)
        }
      );
    }
  };
  controller.doAddByTemplate = doAddByTemplate;

  $scope.goBackToCore = controller.goBackToCore;
  return app.farmnetControllers.finishController(
    eName + 'CoreController',
    $scope,
    controller,
    $injector
  );

  function createTabShowListenerManager() {
    var tabShowListeners = {}; // {<tabName>:[<listener>]} Listeners which are called, if onSelectTab() is called with a matching tab name

    return {
      createRegisterListenerFn: createRegisterListenerFn,
      callListeners: callListeners
    };

    /**
     * Calls the registered listener for a tab when the tab is shown.
     * @param tabName Name of the tab
     */
    function callListeners(tabName) {
      var listeners = tabShowListeners[tabName];
      if (listeners) {
        for (var i = 0; i < listeners.length; i++) {
          listeners[i](tabName);
        }
      }
    }

    /**
     * Registers a listener for a tab name to be called when the tab is selected. This must be
     * @param tabName
     * @param listener
     */
    function registerTabShowListener(tabName, listener) {
      var listeners = tabShowListeners[tabName];
      if (!listeners) {
        listeners = [];
        tabShowListeners[tabName] = listeners;
      }
      listeners.push(listener);
    }

    function deregisterTabShowListener(tabName, listener) {
      var listeners = tabShowListeners[tabName];
      if (listeners) {
        var index = listeners.indexOf(listener);
        if (index !== -1) {
          listeners.splice(index, 1);
        }
      }
    }

    /**
     * Returns a function to register a listener which is called when a tab with a given name is shown.
     * @param tabName Name of the tab
     * @returns {Function} Listener register function. That function returns a deregister function.
     * @see registerTabShowListener
     */
    function createRegisterListenerFn(tabName) {
      return function(listener) {
        registerTabShowListener(tabName, listener);

        return function() {
          deregisterTabShowListener(tabName, listener);
        };
      };
    }
  }
}

function coreCommonResolveFunction(service, hasActive) {
  console.log('coreCommonResolveFunction');
  var stdQuery;

  if (!hasActive) {
    stdQuery = 'query';
  } else {
    stdQuery = 'queryActiveOnly';
  }
  var result = service[stdQuery]({}, function() {
    app.farmnetControllers.data = result;
  });
  return result.$promise;
}

function coreCommonRestService(eName, $resource) {
  return $resource(
    '/365FarmNet/rest/core/' + eName.toLowerCase() + '/:restAction:id',
    {},
    {
      get: { method: 'GET', params: { id: '@id' } },
      save: { method: 'POST' },
      query: { method: 'GET', isArray: true },
      queryActiveOnly: {
        method: 'GET',
        isArray: true,
        params: { restAction: 'ActiveOnly' }
      },
      delete: { method: 'DELETE', params: { id: '@id' } },
      create: { method: 'PUT' },
      call: { method: 'POST', params: { restAction: '@restAction' } },
      /* MSR */
      duplicate: { method: 'POST', params: { restAction: 'duplicate' } }
      /* MSR */
    }
  );
}

global.coreCommonResolveFunction = coreCommonResolveFunction;
global.coreCommonRestService = coreCommonRestService;
global.coreCommonController = coreCommonController;
